import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BraintreeHostedFieldsComponent } from './braintree-hosted-fields.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CreditCardPipeModule } from '@fleet/pipes';
import { MatIconModule } from '@angular/material/icon';
import { PaymentMethodIconModule } from '../payment-method-icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [BraintreeHostedFieldsComponent],
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    CreditCardPipeModule,
    MatIconModule,
    PaymentMethodIconModule,
    MatProgressSpinnerModule,
  ],
  exports: [BraintreeHostedFieldsComponent],
})
export class BraintreeHostedFieldsModule {}
